import React from 'react'

const OfficePolicyPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Office Policy Page</h1>
      <p>This is a placeholder for the Office Policy page.</p>
    </div>
  )
}

export default OfficePolicyPage